export default "__VITE_ASSET__0qKy3zAe__"